"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'accountGrade.form.title.edit': '编辑价格套餐',
    'accountGrade.form.title.add': '添加价格套餐',
    'accountGrade.form.back': '返回',
    'accountGrade.form.name.label': '名称',
    'accountGrade.form.name.placeholder': '价格套餐名称',
    'accountGrade.form.description.label': '描述',
    'accountGrade.form.description.placeholder': '价格套餐描述',
    'accountGrade.form.price.label': '月费',
    'accountGrade.form.price.placeholder': '月费（美元）',
    'accountGrade.form.price.monthly.help': '月订阅价格（美元）',
    'accountGrade.form.yearlyPrice.placeholder': '年费（美元）',
    'accountGrade.form.yearlyPrice.help': '年订阅价格（美元，通常有折扣）',
    'accountGrade.form.creditsPerMonth.placeholder': '每月提供的积分数量',
    'accountGrade.form.creditsPerMonth.help': '积分会自动添加到用户账户中，每月一次',
    'accountGrade.form.active.label': '活跃',
    'accountGrade.form.active.description': '使此价格套餐可用',
    'accountGrade.form.order.label': '顺序',
    'accountGrade.form.order.placeholder': '显示顺序（可选）',
    'accountGrade.form.submit.create': '创建价格套餐',
    'accountGrade.form.submit.update': '更新价格套餐',
    'accountGrade.form.save': '保存价格套餐',
    'accountGrade.form.saving': '保存中...',
    'accountGrade.form.unlimited': '无限制',
};
